import React, { useState, useEffect } from 'react';
import './Blog_section.css';

export function BlogSection() {
    const [activeCategory, setActiveCategory] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [blogPosts, setBlogPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('/blogs')
            .then(response => response.json())
            .then(data => {
                setBlogPosts(data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching blogs:', error);
                setLoading(false);
            });
    }, []);

    const categories = [
        { value: 'all', label: 'All Posts' },
        ...Array.from(new Set(blogPosts.map(post => post.category))).map(category => ({ value: category, label: category.charAt(0).toUpperCase() + category.slice(1) }))
    ];

    const filteredPosts = blogPosts.filter(post => {
        const matchesCategory = activeCategory === 'all' || post.category === activeCategory;
        const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesCategory && matchesSearch;
    });

    return (
        <div className="blog-section">
            <div className="blog-header">
                <h1>Blog & Articles</h1>
                <p>Insights, thoughts, and knowledge shared through my writing</p>
            </div>

            <div className="blog-controls">
                <input
                    type="text"
                    placeholder="Search articles..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                />
                <div className="category-filters">
                    {categories.map(category => (
                        <button
                            key={category.value}
                            className={`category-btn ${activeCategory === category.value ? 'active' : ''}`}
                            onClick={() => setActiveCategory(category.value)}
                        >
                            {category.label}
                        </button>
                    ))}
                </div>
            </div>

            {loading ? (
                <p>Loading blogs...</p>
            ) : filteredPosts.length > 0 ? (
                <div className="blog-posts-grid">
                    {filteredPosts.map(post => (
                        <div className="blog-post-card" key={post.id}>
                            <div className="blog-post-image">
                                <img src={post.image} alt={post.title} />
                            </div>
                            <div className="blog-post-content">
                                <span className="post-category">{post.category}</span>
                                <h3>{post.title}</h3>
                                <p>{post.excerpt}</p>
                                <div className="post-meta">
                                    <span className="post-date">{post.date}</span>
                                    <span className="post-read-time">{post.readTime}</span>
                                </div>
                                <button className="read-more-btn">Read Article</button>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="no-posts">
                    <h3>No blogs currently added</h3>
                    <p>Check back later for new articles.</p>
                </div>
            )}
        </div>
    );
}

export default BlogSection;
